import { db } from './config';
import { getCurrentStaffEmail } from './auth';
import { collection, addDoc, updateDoc, query, where, getDocs, doc } from 'firebase/firestore';

export const saveHairRecord = async (clientId, formData, staffName, userEmail = null) => {
  const staffEmail = userEmail || getCurrentStaffEmail();
  const now = new Date().toISOString();
  
  const existing = await getHairRecord(clientId);
  
  const recordData = {
    clientId,
    recordType: 'hair',
    ...formData,
    staffName,
    updatedBy: staffEmail,
    updatedAt: now
  };
  
  if (existing) {
    const recordRef = doc(db, 'clientRecords', existing.recordId);
    await updateDoc(recordRef, recordData);
    return { ...recordData, recordId: existing.recordId };
  } else {
    recordData.createdBy = staffEmail;
    recordData.createdAt = now;
    const docRef = await addDoc(collection(db, 'clientRecords'), recordData);
    return { ...recordData, recordId: docRef.id };
  }
};

export const saveSkinRecord = async (clientId, formData, staffName, userEmail = null) => {
  const staffEmail = userEmail || getCurrentStaffEmail();
  const now = new Date().toISOString();
  
  const existing = await getSkinRecord(clientId);
  
  const recordData = {
    clientId,
    recordType: 'skin',
    ...formData,
    staffName,
    updatedBy: staffEmail,
    updatedAt: now
  };
  
  if (existing) {
    const recordRef = doc(db, 'clientRecords', existing.recordId);
    await updateDoc(recordRef, recordData);
    return { ...recordData, recordId: existing.recordId };
  } else {
    recordData.createdBy = staffEmail;
    recordData.createdAt = now;
    const docRef = await addDoc(collection(db, 'clientRecords'), recordData);
    return { ...recordData, recordId: docRef.id };
  }
};

export const getHairRecord = async (clientId) => {
  const q = query(
    collection(db, 'clientRecords'), 
    where('clientId', '==', clientId),
    where('recordType', '==', 'hair')
  );
  const snapshot = await getDocs(q);
  if (snapshot.empty) return null;
  const docSnap = snapshot.docs[0];
  return { recordId: docSnap.id, ...docSnap.data() };
};

export const getSkinRecord = async (clientId) => {
  const q = query(
    collection(db, 'clientRecords'), 
    where('clientId', '==', clientId),
    where('recordType', '==', 'skin')
  );
  const snapshot = await getDocs(q);
  if (snapshot.empty) return null;
  const docSnap = snapshot.docs[0];
  return { recordId: docSnap.id, ...docSnap.data() };
};

export const getClientRecords = async (clientId) => {
  const q = query(collection(db, 'clientRecords'), where('clientId', '==', clientId));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ recordId: doc.id, ...doc.data() }));
};
